<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-card width="100%">
        <v-flex lg12 pa-5>
          <v-layout>
            <h2 class="primary--text text-uppercase text-center">
              {{localization.datosVisita.title}} - {{incidencia.visitaReferencia}}
            </h2>
          </v-layout>
          <v-divider class="divider_subtitle"></v-divider>
          <v-list>


            <v-list-item>
              <span class="tituloSeccion gris labelConfig width200dp" v-if="getConfiguracion.PV_VISITA_FECHA_ALTA_CLIENTE">
                <b>{{localization.datosVisita.altaInquilino}}:</b>
                <span class="truncate-text">{{incidencia.fechaAltaCliente}}</span>
              </span>
              <span class="tituloSeccion gris labelConfig width200dp" v-if="getConfiguracion.PV_VISITA_REGISTRO_ENTRADA">
                <b>{{localization.datosVisita.registroEntrada}}:</b>
                <span class="truncate-text">{{incidencia.numRegistro}}</span>
              </span>
            </v-list-item>

            <v-list-item>
              <span class="tituloSeccion gris labelConfig width200dp">
                <b>{{localization.datosVisita.promocion}}:</b>
                <span class="truncate-text">{{incidencia.nombrePromocion}}</span>
              </span>
              <span class="tituloSeccion gris labelConfig width200dp" v-if="incidencia.inmuebleEspecialPromocionId !== null">
                <b>{{localization.datosVisita.provincia}}:</b>
                {{incidencia.promProvincia}}
              </span>
              <span class="tituloSeccion gris labelConfig width200dp" v-if="incidencia.inmuebleEspecialPromocionId === null">
                <b>{{localization.datosVisita.provincia}}:</b>
                <span class="truncate-text">{{incidencia.promProvincia}}</span>
              </span>
              <span class="tituloSeccion gris labelConfig width200dp">
                <b>{{localization.datosVisita.sector}}:</b>
                <span class="truncate-text">{{incidencia.sector}}</span>
              </span>
            </v-list-item>
            <v-list-item v-if="incidencia.inmuebleEspecialPromocionId == null">
              <span class="tituloSeccion gris labelConfig width200dp">
                <b>{{localization.datosVisita.inmueble}}:</b>
                <span class="truncate-text">{{incidencia.alias}} ({{incidencia.uhedit}})</span>
              </span>
            </v-list-item>
            <v-list-item v-if="incidencia.inmuebleEspecialPromocionId != null">
              <span class="tituloSeccion gris labelConfig width200dp">
                <b>{{localization.datosVisita.inmueble}}:</b>
                <span class="truncate-text">{{incidencia.tipoInmuebleEspecial}}</span>
              </span>
              <span v-if="mostrarCPInmueble()" class="tituloSeccion gris labelConfig width200dp">
                <b>{{this.getConfiguracion.codigoPropioNombre}}:</b>
                <span class="truncate-text">{{incidencia.valorCP}}</span>
              </span>
            </v-list-item>
            <v-list-item v-if="incidencia.inmuebleEspecialPromocionId == null">
              <span class="tituloSeccion gris labelConfig width200dp">
                <b>{{localization.datosVisita.direccion}}:</b>
                <span class="truncate-text">{{incidencia.direccion}}</span>
              </span>
              <span class="tituloSeccion gris labelConfig width200dp">
                <b>{{localization.datosVisita.poblacion}}:</b>
                <span class="truncate-text">{{incidencia.poblacion}}</span>
              </span>
              <span v-if="mostrarCPInmueble()" class="tituloSeccion gris labelConfig width200dp">
                <b>{{this.getConfiguracion.codigoPropioNombre}}:</b>
                <span class="truncate-text">{{incidencia.valorCP}}</span>
              </span>
            </v-list-item>
            <v-list-item v-if="incidencia.inmuebleEspecialPromocionId !== null">
              <span class="tituloSeccion gris labelConfig width200dp">
                <b>{{localization.datosVisita.direccion}}:</b>
                <span class="truncate-text">{{incidencia.promDireccion}}</span>
              </span>
              <span class="tituloSeccion gris labelConfig width200dp">
                <b>{{localization.datosVisita.poblacion}}:</b>
                <span class="truncate-text">{{incidencia.promPoblacion}}</span>
              </span>
            </v-list-item>
            <v-list-item v-if="computadaFechaEscrituracion !== null && (incidencia.ambito === 1 || incidencia.ambito === '1')">
              <span class="tituloSeccion gris labelConfig width200dp" v-if="mostrarFechaEscrituraAlquiler">
                <b>{{localization.datosVisita.fechaEscrituracion}}:</b>
                <span class="truncate-text">{{computadaFechaEscrituracion}}</span>
              </span>
            </v-list-item>
            <v-list-item v-if="computadaFechaAlquiler !== null && (incidencia.ambito === 2 || incidencia.ambito === '2')">
              <span class="tituloSeccion gris labelConfig width200dp" v-if="mostrarFechaEscrituraAlquiler && computadaFechaAlquiler !== null">
                <b>{{localization.datosVisita.fechaAlquiler}}:</b>
                <span class="truncate-text">{{computadaFechaAlquiler}}</span>
              </span>
            </v-list-item>
            <v-list-item>
              <span class="tituloSeccion gris labelConfig width200dp">
                <b>{{localization.datosVisita.tipoVisita}}:</b>
                <span class="truncate-text">{{incidencia.tipoVisita}}</span>
              </span>
            </v-list-item>
            <v-list-item>
              <span class="tituloSeccion gris labelConfig width200dp">
                <b>{{localization.datosVisita.fechaAlta}}:</b>
                <span class="truncate-text">{{computadaFechaAlta}}</span>
              </span>
            </v-list-item>
            <v-list-item>
              <span class="tituloSeccion gris labelConfig width200dp">
                <b>{{localization.datosVisita.reportadoPor}}:</b>
                <span class="truncate-text">{{incidencia.reportadoPor}}</span>
              </span>
            </v-list-item>
            <v-list-item v-if="imgFirma.length > 0">
              <span class="tituloSeccion gris labelConfig width200dp">
                <b>{{localization.datosVisita.firma}}</b>
                <v-img v-if="imgFirma.length > 0"
                  v-bind:src="'data:image/jpeg;base64,' + imgFirma[0].smallPicture"
                  @click="expandImg('data:image/*;base64,' + imgFirma[0].smallPicture, imgFirma[0].id)"
                  width="200"
                  height="150"
                  contain>
                </v-img>
              </span>
            </v-list-item>
          </v-list>

          <v-layout mt-3>
            <h2 class="primary--text text-uppercase text-center">
              {{localization.datosCliente.title}}
            </h2>
          </v-layout>
          <v-divider class="divider_subtitle"></v-divider>
          <v-list>
            <v-list-item>
              <span class="tituloSeccion gris labelConfig width100">
                <b>{{localization.datosCliente.nombre}}:</b>
                 <span class="truncate-text">{{incidencia.nombre || incidencia.espNombre}}</span>
              </span>
            </v-list-item>
            <v-list-item>
              <span class="tituloSeccion gris labelConfig width100">
                <b>{{localization.datosCliente.telefono}}:</b>
                 <span class="truncate-text">{{incidencia.telefono || incidencia.espTelefono}}</span>
              </span>
            </v-list-item>
            <v-list-item>
              <span class="tituloSeccion gris labelConfig width100">
                <b>{{localization.datosCliente.movil}}:</b>
                 <span class="truncate-text">{{incidencia.movil || incidencia.espMovil}}</span>
              </span>
            </v-list-item>
            <v-list-item>
              <span class="tituloSeccion gris labelConfig width100">
                <b>{{localization.datosCliente.email}}:</b>
                 <span class="truncate-text">{{incidencia.email || incidencia.espEmail}}</span>
              </span>
            </v-list-item>
          </v-list>

          <v-layout mt-3 lg12>
            <h2 class="primary--text text-uppercase text-center">
               <span>{{localization.contactoVisita.title}}</span>
            </h2>
          </v-layout>
          <v-divider class="divider_subtitle"></v-divider>
          <v-list>
            <v-list-item>
              <span class="tituloSeccion gris labelConfig width100">
                <b>{{localization.contactoVisita.nombre}}:</b> {{incidencia.nombreContacto}}
              </span>
            </v-list-item>
            <v-list-item>
              <span class="tituloSeccion gris labelConfig width100">
                <b>{{localization.contactoVisita.telefono}}:</b> {{incidencia.telefonoContacto}}
              </span>
            </v-list-item>
            <v-list-item>
              <span class="tituloSeccion gris labelConfig width100">
                <b>{{localization.contactoVisita.movil}}:</b> {{incidencia.movilContacto}}
              </span>
            </v-list-item>
            <v-list-item>
              <span class="tituloSeccion gris labelConfig width100">
                <b>{{localization.contactoVisita.email}}:</b> {{incidencia.emailContacto}}
              </span>
            </v-list-item>
          </v-list>
        </v-flex>
      </v-card>
    </v-layout>
    <FullSizeImg :imgId="imgId" :imgUrl="imgUrl" v-model="openFullSize" id="openFullSize" />
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import FullSizeImg from '../../custom/fullSizeImgPopUp'

export default {
  props: {
    incidencia: {}
  },
  components: {
    FullSizeImg
  },
  data () {
    return {
      openFullSize: false,
      imgUrl: '',
      imgId: null,
      mostrarFechaEscrituraAlquiler: false
    }
  },
  mounted () {
    this.mostrarFechaEscrituraAlquiler = this.idubapi.motor !== 'SIN_BD'
    this.callImgFirma()
  },
  methods: {
    ...mapActions({
      getImgFirma: 'incidencias/getImgFirma'
    }),
    callImgFirma () {

      const values = {
        objetoId: this.incidencia.visitaId,
        tipoObjetoId: '3',
        carpetaId: '2'
      }
      this.getImgFirma(values)
    },
    expandImg (data, id) {
      this.imgUrl = data
      this.imgId = id
      console.log(this.imgUrl)
      this.openFullSize = true
    },
    mostrarCPInmueble () {
      return this.getConfiguracion.codigoPropioNombre !== 'NFORMACIÓN ADICIONAL'
    }
  },
  computed: {
    ...mapGetters({
      getConfiguracion: 'configuracion/getConfiguracion',
      idubapi: 'login/idubapi'
    }),
    localization () {
      return this.$t('verIncidencia.datosVisita')
    },
    computadaFechaAlta () {
      return (this.incidencia.fecha) ? moment(this.incidencia.fecha, 'DD-MM-YYYY').format('DD/MM/YYYY') : null
    },
    computadaFechaEscrituracion () {
      return (this.incidencia.fechaEscrituracion) ? moment(this.incidencia.fechaEscrituracion, 'DD-MM-YYYY').format('DD/MM/YYYY') : null
    },
    computadaFechaAlquiler () {
      return (this.incidencia.fechaAlquiler) ? moment(this.incidencia.fechaAlquiler, 'DD-MM-YYYY').format('DD/MM/YYYY') : null
    },
    imgFirma () {
      if (this.$store.state.incidencias.imgFirma) {
        return this.$store.state.incidencias.imgFirma
      }
      return []
    }
  }
}
</script>

<style scoped>
  .width100 {
    width: 100%
  }
  .width200dp {
    width: 200
  }
  .truncate-text {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 70%; /* your width */
    display: block;
    overflow: hidden
}
</style>
